import React from 'react';
import { Input, Chip, Button } from '@heroui/react';
import { MagnifyingGlass, X, CaretLeft, CaretRight } from '@phosphor-icons/react';

interface PropertySearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  matchCount?: number;
  totalCount?: number;
  currentMatchIndex?: number;
  onNavigateToPrevious?: () => void;
  onNavigateToNext?: () => void;
}

const PropertySearch: React.FC<PropertySearchProps> = ({
  searchQuery,
  onSearchChange,
  matchCount,
  totalCount,
  currentMatchIndex,
  onNavigateToPrevious,
  onNavigateToNext,
}) => {
  const hasMatches = searchQuery && matchCount && matchCount > 0;
  const showNavigation = hasMatches && onNavigateToPrevious && onNavigateToNext;

  return (
    <div className="flex items-center gap-3 p-4">
      <Input
        className="flex-1"
        placeholder="Zoek eigenschappen op naam..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        startContent={<MagnifyingGlass size={20} className="text-gray-400" />}
        endContent={
          searchQuery && (
            <button
              onClick={() => onSearchChange('')}
              className="text-gray-400 hover:text-gray-600"
            >
              <X size={18} />
            </button>
          )
        }
        variant="bordered"
        size="lg"
      />

      {searchQuery && matchCount !== undefined && totalCount !== undefined && (
        <Chip
          size="lg"
          variant="flat"
          color={matchCount > 0 ? 'success' : 'default'}
        >
          {matchCount} van {totalCount} eigenschappen
        </Chip>
      )}

      {showNavigation && (
        <>
          <Chip
            size="lg"
            variant="flat"
            color="primary"
          >
            {(currentMatchIndex ?? 0) + 1} van {matchCount}
          </Chip>

          <div className="flex gap-1">
            <Button
              isIconOnly
              size="sm"
              variant="flat"
              color="primary"
              onPress={onNavigateToPrevious}
              isDisabled={!matchCount || matchCount === 0}
            >
              <CaretLeft size={20} weight="bold" />
            </Button>

            <Button
              isIconOnly
              size="sm"
              variant="flat"
              color="primary"
              onPress={onNavigateToNext}
              isDisabled={!matchCount || matchCount === 0}
            >
              <CaretRight size={20} weight="bold" />
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default PropertySearch;
